(function () {
    'use strict';

    angular.module("imApp").factory("productSettingMcItemService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3562,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3563,
                    parameters: edit
                });
            },
            delete: function (edit) {
                return $ihttp.post({
                    method: 3564,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
